import {gql} from '@apollo/client'
export const companyDeviceTrend=gql`
query Query($company: String!, $year: Int!, $months: [Int]!) {
    companyDeviceTrend(company: $company, year: $year, months: $months) {
      year
      month
      deviceCount
      measureCount
    }
  }
`
export const queryDeviceUsageByMonth=gql`
query Query($company: String!, $year: Int, $month: Int) {
  getDeviceUsageByMonth(company: $company, year: $year, month: $month) {
    deviceModel
    activeCount
    measureCount
  }
}
`